import { useEffect, useState } from "react";
import { Button, Card, FormLayout, Layout, Page, Text, TextField } from "@shopify/polaris";
import agent from "../../app/api/agent";
import PreviewImportsPage from "./PreviewImportsPage";
import PreviewAtdProductsPage from "./PreviewAtdProductsPage";
import { clearPreviewToken, getPreviewToken, setPreviewToken } from "./previewAuth";

export default function PreviewPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState<string | null>(null);
  const [scope, setScope] = useState<"aces" | "atd" | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleLogout = () => {
    clearPreviewToken();
    setToken(null);
    setScope(null);
    setError(null);
  };

  useEffect(() => {
    const existingToken = getPreviewToken();
    setToken(existingToken);

    if (!existingToken) return;

    agent.Preview.session(existingToken)
      .then((result) => setScope(result.scope))
      .catch(() => handleLogout());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = async () => {
    setError(null);

    try {
      const response = await agent.Preview.login(email, password);
      setPreviewToken(response.token);
      setToken(response.token);
      setScope((response.scope === "atd" ? "atd" : "aces"));
    } catch {
      setError("Invalid preview credentials.");
    }
  };

  if (!token) {
    return (
      <Page fullWidth title="PartFinder Preview Console">
        <Layout>
          <Layout.Section>
            <Card>
              <FormLayout>
                <Text as="h2" variant="headingMd">Preview login</Text>
                <TextField label="Email" value={email} onChange={setEmail} autoComplete="email" />
                <TextField label="Password" value={password} onChange={setPassword} type="password" autoComplete="current-password" />
                <Button variant="primary" onClick={handleLogin}>Sign in</Button>
                {error ? <Text as="p" tone="critical">{error}</Text> : null}
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  if (scope === "atd") {
    return <PreviewAtdProductsPage token={token} onUnauthorized={handleLogout} onLogout={handleLogout} />;
  }

  return <PreviewImportsPage token={token} onUnauthorized={handleLogout} onLogout={handleLogout} />;
}
